"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _moment = _interopRequireDefault(require("moment"));
function getServerTime(timestamp, serverTimeDelta) {
  return _moment["default"].unix(timestamp).subtract(serverTimeDelta, 'seconds').unix();
}
var _default = exports["default"] = getServerTime;